import { render } from "./CollectionMultipleDrag.vue?vue&type=template&id=fcb7728e&scoped=true"
import script from "./CollectionMultipleDrag.vue?vue&type=script&lang=js"
export * from "./CollectionMultipleDrag.vue?vue&type=script&lang=js"

import "./CollectionMultipleDrag.vue?vue&type=style&index=0&id=fcb7728e&lang=css&scoped=true"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcb7728e"]])

export default __exports__